<template>
  <b-badge
    class="log-times-badge d-inline-flex"
    pill
    v-if="timeOff"
  >
    <template>
      <a
        @click.prevent="showTimeOffsModal('view')"
        href="#"
        class="d-flex align-items-center"
        :class="{ 'disabled': !$can('read_all-time_offs') }"
        title="View time off"
        v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }">
        <span class="material-symbols-outlined text-editor__block-icon has-comment">
          visibility
        </span>
      </a>
    </template>
    <template v-if="isRequestor">
      <a
        @click.prevent="showTimeOffsModal('edit')"
        href="#"
        :class="{ 'disabled': !$can('update_own-time_offs') }"
        title="Edit time off"
        v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }">
        <span v-html="editIconSvg"></span>
      </a>
    </template>
    <template v-if="isApprover && isPending">
      <a
        @click.prevent="showTimeOffsModal('approve')"
        href="#"
        :class="{ 'disabled': !$can('update_all-time_offs') }"
        title="Approve time off"
        v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }">
        <span class="material-symbols-outlined">
          thumb_up
        </span>
      </a>
    </template>
    <template v-if="isApprover || isRequestor">
      <a
        @click.prevent="deleteTimeOff"
        :class="{ 'disabled': !$can('delete-time_offs') }"
        href="#"
        title="Delete time off"
        v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }">
        <span v-html="removeIconSvg"></span>
      </a>
    </template>
    <TimeOffFormModal
      v-if="showForm"
      v-model="showForm"
      :dataProps="form"
      :mode="mode"
      :modal="true"
      :show-preloader="true"
      @save="editTimeOff"
      @approve="approveTimeOff"
      @decline="declineTimeOff"
    />
    <ViewTimeOffModal
      v-model="showViewModal"
      :mode="mode"
      :title="mode === 'approve' ? 'Approve time off' : undefined"
      :timeOff="timeOff"
      :isLoading="getIsModalLoading"
      @approve="approveTimeOff"
      @decline="declineTimeOff"
      @edit="handleEditFromView"
      @deletedTimeOff="$emit('deletedTimeOff', $event)"
    />
  </b-badge>
</template>
<script>
import { cloneDeep } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import TimeOffFormModal from '../components/modals/TimeOffFormModal.vue'
import ViewTimeOffModal from '../components/modals/ViewTimeOffModal.vue'
import TimeOffs from '../mixins/TimeOffs'
import editIcon from '@/assets/icons/editIcon'
import removeIcon from '@/assets/icons/removeIcon'

export default {
  name: 'TimeOffLinks',
  components: {
    TimeOffFormModal,
    ViewTimeOffModal
  },
  mixins: [TimeOffs],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    onDelete: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      mode: 'view',
      removeIconSvg: removeIcon({ size: 'lg' }),
      editIconSvg: editIcon({ size: 'lg' }),
      form: {},
      showViewModal: false
    }
  },
  async mounted () {
    if (this.isApprover && this.isPending) {
      this.mode = 'approve'
    } else if (this.isRequestor && this.isPending) {
      this.mode = 'edit'
    } else {
      this.mode = 'view'
    }
  },
  computed: {
    ...mapGetters({
      getIsModalLoading: 'finances/getIsModalLoading'
    })
  },
  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler (item) {
        this.timeOff = item
      }
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    editTimeOff (data) {
      this.setIsModalLoading(true)
      this.$api.timeOffs.editTimeOff(data)
        .then(({ data, status }) => {
          this.$snotify.success(
            'Time off successfully saved',
            'Success',
            this.$store.state.snotify
          )

          this.hideTimeOffsModal()
          this.form = {}
          this.timeOff = cloneDeep(data)
          this.$emit('updatedTimeOff', { data: this.timeOff, status })
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.setIsModalLoading(false)
        })
    },
    showTimeOffsModal (mode) {
      this.mode = mode
      this.setIsModalLoading(false)

      if (mode === 'view' || mode === 'approve') {
        this.showViewModal = true
        return
      }

      if (!this.$can('update_own-time_off')) {
        return
      }
      this.form = cloneDeep(this.timeOff)
      this.showForm = true
    },
    handleEditFromView () {
      this.showViewModal = false
      this.showTimeOffsModal('edit')
    },
    async deleteTimeOff () {
      if (!this.$can('delete-time_off')) {
        return false
      }
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete time off period from ' + this.timeOff.date_from + ' to ' + this.timeOff.date_to + ' ?'
      )
      if (!confirm) {
        return
      }

      const deleteHandler = this.onDelete ? this.onDelete() : null
      if (deleteHandler && deleteHandler.setLoading) {
        deleteHandler.setLoading(true)
      } else {
        this.setIsModalLoading(true)
      }

      this.$api.timeOffs.removeTimeOff(this.timeOff.id)
        .then(() => {
          this.$snotify.success(
            'Time off successfully deleted',
            'Success',
            this.$store.state.snotify
          )
          this.$emit('deletedTimeOff', { data: this.timeOff.id })
        })
        .catch(error => {
          this.errorNotifications(error)
        })
        .finally(() => {
          if (deleteHandler && deleteHandler.setLoading) {
            deleteHandler.setLoading(false)
          } else {
            this.setIsModalLoading(false)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.log-times-badge {
  gap: 5.5px;
  padding: 0;
  font-size: 14px;
  background-color: transparent;

  a {
    cursor: pointer;
    color: #3d5170;
    margin-top: 1px;

    & .material-symbols-outlined {
      font-size: 20px;
    }
  }

  .edit {
    font-size: 18px;
    position: relative;
    bottom: 1px;
  }
}

.eye-icon, .delete-icon {
  position: relative;
  top: -2px;
  font-size: 20px;
}
</style>
